module.exports = __webpack_public_path__ + "static/media/paypal.1f935cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pay-methods/paypal.png
// module id = 1369
// module chunks = 0